module.exports = __webpack_public_path__ + "img/Vector.9d95d6ee.svg";